import { StyleSheet } from 'aphrodite';

export const s = StyleSheet.create({
	footer: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		marginTop: 24,
	},
});
